"use client"

// src/grid.tsx
import { forwardRef, transforms, ui, useTheme } from "@yamada-ui/core";
import { getMemoizedObject as get, replaceObject } from "@yamada-ui/utils";
import { jsx } from "react/jsx-runtime";
var Grid = forwardRef(
  ({
    area: gridArea,
    autoColumns: gridAutoColumns,
    autoFlow: gridAutoFlow,
    autoRows: gridAutoRows,
    column: gridColumn,
    columnGap,
    gap,
    row: gridRow,
    rowGap,
    templateAreas: gridTemplateAreas,
    templateColumns: gridTemplateColumns,
    templateRows: gridTemplateRows,
    ...rest
  }, ref) => {
    const css = {
      columnGap,
      display: "grid",
      gap,
      gridArea,
      gridAutoColumns,
      gridAutoFlow,
      gridAutoRows,
      gridColumn,
      gridRow,
      gridTemplateAreas,
      gridTemplateColumns,
      gridTemplateRows,
      rowGap
    };
    return /* @__PURE__ */ jsx(ui.div, { ref, __css: css, ...rest });
  }
);
Grid.displayName = "Grid";
Grid.__ui__ = "Grid";
var transformColumns = (columns, minWidth) => (theme) => {
  if (minWidth) {
    return replaceObject(minWidth, (value) => {
      value = get(theme, `sizes.${value}`, transforms.px(value));
      return value != null ? `repeat(auto-fit, minmax(${value}, 1fr))` : void 0;
    });
  } else {
    return replaceObject(
      columns,
      (value) => value != null ? `repeat(${value}, minmax(0, 1fr))` : void 0
    );
  }
};
var SimpleGrid = forwardRef(
  ({ columns, minChildWidth, ...rest }, ref) => {
    const { theme } = useTheme();
    const templateColumns = transformColumns(columns, minChildWidth)(theme);
    return /* @__PURE__ */ jsx(Grid, { ref, templateColumns, ...rest });
  }
);
SimpleGrid.displayName = "SimpleGrid";
SimpleGrid.__ui__ = "SimpleGrid";
var GridItem = forwardRef(
  ({
    area: gridArea,
    colEnd: gridColumnEnd,
    colSpan,
    colStart: gridColumnStart,
    rowEnd: gridRowEnd,
    rowSpan,
    rowStart: gridRowStart,
    ...rest
  }, ref) => {
    const css = {
      gridArea,
      gridColumn: replaceObject(
        colSpan,
        (value) => value != null ? `span ${value}/span ${value}` : void 0
      ),
      gridColumnEnd,
      gridColumnStart,
      gridRow: replaceObject(
        rowSpan,
        (value) => value != null ? `span ${value}/span ${value}` : void 0
      ),
      gridRowEnd,
      gridRowStart
    };
    return /* @__PURE__ */ jsx(ui.div, { ref, __css: css, ...rest });
  }
);
GridItem.displayName = "GridItem";
GridItem.__ui__ = "GridItem";

export {
  Grid,
  SimpleGrid,
  GridItem
};
//# sourceMappingURL=chunk-47MRLSTR.mjs.map